// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.drop-toggle {
  background-color: #fff;
  padding: 5px 10px;
  border-radius: 4px;
  cursor: pointer;
  cursor: hand;
  border: 1px solid #ccc;
  min-width: 233px;
  max-width: 100%;
  text-align: left;
  position: relative;
  padding-right: 28px;
}

.drop-toggle i {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
}

.drop-show {
  padding: 4px;
  width: 222px;
  background-color: #fff;
  border: 1px solid #bababa;
  position: absolute;
  z-index: 100;
  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.15);
  margin-left: 1px;
}

.drop-show label {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 15px;
  cursor: pointer;
}

.drop-show label input {
  margin: 0;
}

.item-box {
  background-color: #d9d9d9;
  border-radius: 50px;
  padding: 0.1rem 0.5rem 0.1rem 0.5rem;
  margin-right: 0.2rem;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
